import googleIcon from 'assets/images/googleIcon.svg';
import { Button } from 'components/buttons';
import { useIsLanding } from 'modules/promoLandings/hooks/useIsLanding';
import { useIsRegModalFlow } from 'modules/promoLandings/hooks/useIsRegModalFlow';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IS_GOOGLE_AUTH_HIDDEN } from '../../constants';
import { isOAuthUnsupported } from '../../helpers/isOAuthUnsupported';
import { useGoogleAuth } from '../../hooks/useGoogleAuth';
import { ScGoogleAuthButton, ScGoogleAuthDivider } from './styled';

interface IGoogleAuthButtonProps {
  disabled?: boolean;
  onSendGAEvent: () => void;
  redirect?: string;
}

export const GoogleAuthButton: FC<IGoogleAuthButtonProps> = ({
  disabled,
  onSendGAEvent,
  redirect,
}) => {
  const { t } = useTranslation('common');

  const { isLanding } = useIsLanding();
  const isRegModalFlow = useIsRegModalFlow();
  const { startGoogleAuth, pending } = useGoogleAuth(onSendGAEvent, redirect);

  if (
    isLanding ||
    isRegModalFlow ||
    IS_GOOGLE_AUTH_HIDDEN ||
    isOAuthUnsupported()
  ) {
    return null;
  }

  return (
    <>
      <ScGoogleAuthDivider>
        <span className="text-divider">{t('auth.googleAuth.divider')}</span>
      </ScGoogleAuthDivider>
      <ScGoogleAuthButton>
        <Button
          disabled={disabled || pending}
          onClick={startGoogleAuth}
          pending={pending}
          whiteTransparent
          wide
          xLarge
        >
          <img
            alt=""
            className="google-icon"
            height={24}
            src={googleIcon}
            width={24}
          />
          {t('auth.googleAuth.button')}
        </Button>
      </ScGoogleAuthButton>
    </>
  );
};
